/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';
import { AiOutlineCheckCircle } from 'react-icons/ai';

export const Container = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: ${(props) =>
    props.customStyles && props.customStyles.width
      ? props.customStyles.width
      : '100%'};
  display: flex;
  align-items: center;

  color: ${({ theme }) => theme.colors.gray};
  svg {
    color: ${({ theme }) => theme.colors.gray};
    path {
      &.b {
        color: ${({ theme }) => theme.colors.gray};
        fill: ${({ theme }) => theme.colors.gray};
      }
    }
  }

  padding: 8px 12px 8px 12px;
  height: ${(props) =>
    props.customStyles && props.customStyles.height
      ? props.customStyles.height
      : '50px'};
  transition: border-color 0.5s, color 0.5s;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #dc3545;
      svg {
        color: #dc3545;
        path {
          &.b {
            color: #dc3545;
            fill: #dc3545;
          }
        }
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${props.borderHighlightColor};
      svg {
        color: ${props.borderHighlightColor};

        path {
          &.b {
            color: ${props.borderHighlightColor};
            fill: ${props.borderHighlightColor};
          }
        }
      }
    `}

    ${(props) =>
    props.disabled &&
    css`
      border: 1px solid #c1c1c1;
      background-color: #eeeeee;
    `}

    svg:first-child {
    margin-right: 7px;
  }

  svg:last-child {
    margin-left: 7px;
  }

  .react-datepicker__header {
    background-image: ${(props) => props.theme.gradient.top};

    button {
      border: none;
      background: none;
    }
  }

  .react-datepicker__day-name {
    color: white;
  }

  .react-datepicker__day--selected {
    background-color: ${({ theme }) => theme.colors.purple};
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${({ theme }) => theme.colors.purple};
  }

  input {
    display: flex;
    flex: 1;
    width: 100%;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;

  span {
    color: ${({ theme }) => theme.colors.lightGray};
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    color: ${(props) =>
      props.abastecimento ? '#B4B4B4' : props.theme.colors.lightGray};
    outline: none !important;
    padding: 0;
    margin-top: -5px;

    font-size: ${(props) => (props.abastecimento ? '14px' : '16px')};

    &::placeholder {
      color: ${(props) => (props.abastecimento ? '#B4B4B4' : '#666360')};
    }

    &:hover {
      cursor: pointer;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
`;

export const LabelText = styled.span`
  color: ${({ theme }) => theme.colors.mediumGray};

  position: absolute;
  padding-top: 2px;

  transition: font-size 1s;
  transform: translateY(-3px);

  font-weight: 400;
  font-size: ${({ labelActivated }) =>
    labelActivated ? '0.625rem' : '0.875rem'};

  ${(props) =>
    props.labelActivated &&
    css`
      position: initial;
      transform: translateY(0);
    `}
`;

export const CorrectIcon = styled(AiOutlineCheckCircle)`
  color: #49c4d8 !important;
`;

export const Eye = styled.span`
  width: 40px;
  line-height: 1.75;
  font-size: 1.5rem;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  user-select: none;

  color: ${({ theme }) => theme.colors.gray};
`;

export const ButttonArrow = styled.button`
  svg {
    color: white;
  }
`;

export const CalendarHeaderOptions = styled.div`
  margin: 10px;
  display: flex;
  place-content: center;
  place-items: center;

  select + select {
    margin-left: 10px;
  }

  select {
    border-radius: 4px;
  }
`;
